export default {
  title: 'PMIS Search',
  labels: {
    search: 'Search by PMIS name or code',
    searchDocuments: 'Search by support code, name or type',
    results: 'Results',
    configurations: 'PMIS Configurations',
    addConfiguration: 'Add configuration',
    deleteConfiguration: 'Are you sure you want to delete the PMIS configuration?',
    cannotRevert: 'This action cannot be reverted',
    agreementsTitle: 'Agreements',
    servicesTitle: 'Services',
    supportsTitle: 'Supports',
    searchAlert: 'You must enter a PMIS name or code',
  },
  headers: {
    code: 'Code',
    name: 'Name',
    services: 'Services',
    agreementCodes: 'Agreement codes',
    supportsRequired: 'Required supports',
    actions: 'Actions',
  },
  detail: {
    title: 'PMIS Configuration {code}',
    agreements: 'Affected agreements',
    addAgreement: 'Add agreement',
    services: 'Affected services',
    addService: 'Add service',
    supports: 'Affected supports',
    addSupport: 'Add support',
    updateSuccess: 'PMIS configuration updated successfully',
    updateError: 'Error updating PMIS configuration',
    searchAgreement: 'Search by agreement code',
    searchSupports: 'Search by support code, name or type',
    productHeaders: {
      code: 'Code',
      name: 'PMIS name',
      agreementCode: 'Agreement code',
    },
    agreementHeaders: {
      code: 'Code',
      payer: 'Payer',
      serviceTypes: 'Service types',
      actions: 'Actions',
    },
    serviceHeaders: {
      code: 'Service code',
      name: 'Service name',
      actions: 'Actions',
    },
    supportHeaders: {
      code: 'Support code',
      name: 'Support name',
      type: 'Support type',
      actions: 'Actions',
      required: 'Required'
    },
  }
}
